import { useEffect, useState } from "react";
import { Megaphone, X } from "lucide-react";
import api from "@/lib/api";

export const DistrictNoticeBanner = () => {
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    api.get("/staff/notices").then(({ data }) => {
      const latest = data[0];
      if (latest && localStorage.getItem("dismissed_notice") !== latest.id) setNotice(latest);
    }).catch(() => {});
  }, []);

  if (!notice) return null;
  return (
    <div className="flex items-start gap-3 bg-indigo-600 text-white px-4 py-2.5 text-sm" data-testid="district-notice-banner">
      <Megaphone className="h-4 w-4 mt-0.5 shrink-0" />
      <div className="flex-1 min-w-0">
        <span className="font-semibold">{notice.sender_name}: </span>
        <span className="opacity-95">{notice.body}</span>
        <span className="ml-2 text-[11px] opacity-70">
          {new Date(notice.created_at).toLocaleDateString([], { month: "short", day: "numeric" })}
        </span>
      </div>
      <button
        onClick={() => { localStorage.setItem("dismissed_notice", notice.id); setNotice(null); }}
        data-testid="district-notice-dismiss"
        className="h-6 w-6 shrink-0 rounded-md hover:bg-white/15 inline-flex items-center justify-center"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};
